import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HandleType, ServiceHandle } from '../db/models/service-handle';

@Injectable()
export class HandlesService {

  // private apiUrl = 'https://localhost:44352/api/handleType/';
  // private _baseUrl = 'https://localhost:44352/api/serviceHandles/'

  private apiUrl = 'https://api.trepezserver.com/api/handleType/';
  private _baseUrl = 'https://api.trepezserver.com/api/serviceHandles/';

  headers = new HttpHeaders()
  .set('Content-Type','application/json')
  .set('Access-Control-Allow-Origin','*')
  .set('X-Requested-With', 'XMLHttpRequest')

constructor(private http: HttpClient) { }

getAllHandleTypes(): Observable<HandleType[]> {
  return this.http.get<HandleType[]>(this.apiUrl + 'handles')
}

addServiceHandle(data: ServiceHandle): Observable<ServiceHandle> {
  return this.http.post<ServiceHandle>(this._baseUrl + 'newServiceHandle', data, { 'headers': this.headers });
}

getHandleDetail(id:string): Observable<ServiceHandle>{
  return this.http.get<ServiceHandle>(this._baseUrl + 'servicehandle/' + id)
}

updateServiceHandle(data: ServiceHandle): Observable<ServiceHandle> {
  return this.http.post<ServiceHandle>(this._baseUrl + 'modifyservicehandle/' + data.id, data, { 'headers': this.headers });
}

deleteServiceCategory(data: ServiceHandle): Observable<ServiceHandle> {
  return this.http.post<ServiceHandle>(this._baseUrl + 'removeServicehandle/' + data.id, { 'headers': this.headers })
}

}
